"use client"

import type React from "react"

interface ChainInfo {
  name: string
  url: string
  logo: React.ReactNode
}

export function SupportedChains() {
  const chains: ChainInfo[] = [
    {
      name: "Ethereum",
      url: "https://ethereum.org",
      logo: (
        <svg
          fill="currentColor"
          viewBox="0 0 115 182"
          height="46"
          width="46"
          xmlns="http://www.w3.org/2000/svg"
          className="text-gray-800"
        >
          <path
            d="M57.5054 181V135.84L1.64064 103.171L57.5054 181Z"
            fill="#F0CDC2"
            stroke="#1616B4"
            strokeLinejoin="round"
          />
          <path
            d="M57.6906 181V135.84L113.555 103.171L57.6906 181Z"
            fill="#C9B3F5"
            stroke="#1616B4"
            strokeLinejoin="round"
          />
          <path
            d="M57.5055 124.615V66.9786L1 92.2811L57.5055 124.615Z"
            fill="#88AAF1"
            stroke="#1616B4"
            strokeLinejoin="round"
          />
          <path
            d="M57.6903 124.615V66.9786L114.196 92.2811L57.6903 124.615Z"
            fill="#C9B3F5"
            stroke="#1616B4"
            strokeLinejoin="round"
          />
          <path
            d="M1.00006 92.2811L57.5054 1V66.9786L1.00006 92.2811Z"
            fill="#F0CDC2"
            stroke="#1616B4"
            strokeLinejoin="round"
          />
          <path
            d="M114.196 92.2811L57.6906 1V66.9786L114.196 92.2811Z"
            fill="#B8FAF6"
            stroke="#1616B4"
            strokeLinejoin="round"
          />
        </svg>
      ),
    },
    {
      name: "Base",
      url: "https://base.org",
      logo: (
        <svg xmlns="http://www.w3.org/2000/svg" width="46" height="46" viewBox="0 0 46 46" fill="none">
          <g filter="url(#filter0_b_139_1266)">
            <rect width="46" height="46" rx="23" fill="black" fillOpacity="0.9" />
            <path
              d="M22.9803 34.3703C29.2728 34.3703 34.3739 29.2796 34.3739 23.0001C34.3739 16.7205 29.2728 11.6299 22.9803 11.6299C17.0104 11.6299 12.1129 16.212 11.6265 22.0443H26.6861V23.9558H11.6265C12.1129 29.7882 17.0104 34.3703 22.9803 34.3703Z"
              fill="#E3E7E9"
            />
          </g>
          <defs>
            <filter
              id="filter0_b_139_1266"
              x="-14"
              y="-14"
              width="74"
              height="74"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feGaussianBlur in="BackgroundImageFix" stdDeviation="7" />
              <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_139_1266" />
              <feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_139_1266" result="shape" />
            </filter>
          </defs>
        </svg>
      ),
    },
    {
      name: "Ronin",
      url: "https://roninchain.com",
      logo: (
        <svg xmlns="http://www.w3.org/2000/svg" width="46" height="46" viewBox="0 0 23 31" fill="none">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 2.36932V21.3712C0.000222641 21.7262 0.0804854 22.0765 0.234859 22.3964C0.389232 22.7162 0.613772 22.9975 0.891892 23.2193L9.88514 30.4102C10.2015 30.6625 10.5947 30.8 11 30.8C11.4053 30.8 11.7985 30.6625 12.1149 30.4102L21.1081 23.2193C21.3862 22.9975 21.6108 22.7162 21.7651 22.3964C21.9195 22.0765 21.9998 21.7262 22 21.3712V2.36932C22 1.74093 21.7494 1.13829 21.3034 0.693956C20.8574 0.249624 20.2524 0 19.6216 0H2.37838C1.74759 0 1.14264 0.249624 0.696611 0.693956C0.250578 1.13829 0 1.74093 0 2.36932Z"
            fill="#004DE5"
          />
          <path
            d="M17.413 10.9788V6.83733C17.413 6.28814 17.1967 5.76144 16.8118 5.37311C16.4268 4.98477 15.9047 4.7666 15.3603 4.7666H6.63621C6.0918 4.7666 5.56968 4.98477 5.18472 5.37311C4.79976 5.76144 4.5835 6.28814 4.5835 6.83733V18.854C4.58369 19.1642 4.65296 19.4704 4.7862 19.75C4.91943 20.0296 5.11323 20.2753 5.35327 20.4692L8.52985 23.0421C8.56755 23.073 8.61317 23.0924 8.66139 23.0981C8.70961 23.1039 8.75846 23.0957 8.80226 23.0746C8.84606 23.0534 8.88301 23.0202 8.90882 22.9787C8.93464 22.9372 8.94825 22.8892 8.94809 22.8402V14.3437C8.94809 14.2751 8.97512 14.2092 9.02324 14.1607C9.07136 14.1122 9.13662 14.0849 9.20468 14.0849H11.514C11.9223 14.0849 12.3139 14.2485 12.6026 14.5398C12.8913 14.831 13.0535 15.226 13.0535 15.6379V22.8402C13.0536 22.889 13.0672 22.9367 13.093 22.978C13.1187 23.0192 13.1555 23.0523 13.1991 23.0734C13.2426 23.0945 13.2912 23.1028 13.3392 23.0972C13.3873 23.0917 13.4328 23.0726 13.4705 23.0421L16.6471 20.4692C16.8871 20.2753 17.0809 20.0296 17.2141 19.75C17.3474 19.4704 17.4166 19.1642 17.4168 18.854V15.1203C17.4168 14.5711 17.2006 14.0444 16.8156 13.656C16.4306 13.2677 15.9085 13.0495 15.3641 13.0495C15.9079 13.0485 16.429 12.8299 16.8131 12.4417C17.1972 12.0534 17.413 11.5273 17.413 10.9788ZM11.5114 12.0142H9.20211C9.13406 12.0142 9.06879 11.9869 9.02067 11.9384C8.97255 11.8898 8.94552 11.824 8.94552 11.7553V7.09617C8.94552 7.02753 8.97255 6.96169 9.02067 6.91315C9.06879 6.8646 9.13406 6.83733 9.20211 6.83733H12.7944C12.8624 6.83733 12.9277 6.8646 12.9758 6.91315C13.0239 6.96169 13.051 7.02753 13.051 7.09617V10.4611C13.051 10.873 12.8888 11.268 12.6 11.5593C12.3113 11.8505 11.9197 12.0142 11.5114 12.0142Z"
            fill="url(#paint0_linear_2323_21371)"
          />
          <defs>
            <linearGradient
              id="paint0_linear_2323_21371"
              x1="11.0002"
              y1="4.7666"
              x2="11.0002"
              y2="23.0999"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="white" />
              <stop offset="0.458333" stopColor="white" />
              <stop offset="1" stopColor="white" />
            </linearGradient>
          </defs>
        </svg>
      ),
    },
  ]

  return (
    <div className="w-full">
      <h2 className="text-3xl font-bold text-gray-900 mb-12 tracking-tight font-funnel text-center">
        Supported Chains
      </h2>
      <div className="flex flex-wrap justify-center items-center gap-12 md:gap-16 lg:gap-24">
        {chains.map((chain) => (
          <div
            key={chain.name}
            className="flex flex-col items-center group transition-opacity duration-200 hover:opacity-80 select-none"
          >
            {/* Link temporarily disabled */}
            {/* <a href={chain.url} target="_blank" rel="noopener noreferrer" className="flex flex-col items-center"> */}
            <div className="relative w-20 h-20 mb-3 flex items-center justify-center">{chain.logo}</div>
            <span className="text-sm font-medium text-gray-700 group-hover:text-brand-purple transition-colors">
              {chain.name}
            </span>
            {/* </a> */}
          </div>
        ))}
      </div>
    </div>
  )
}
